module.exports = __webpack_public_path__ + "media/components/assets/img/bg/cloud-top-ce372f3c5133877662355bcd83c8e6ff.svg";